module.exports = __webpack_public_path__ + "img/complaintSectors.67e9b0b4.svg";